import { CurrentUserService } from '../services/current-user.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const redirectProjectListing = () => {
  const router = inject(Router);
  const currentUserService = inject(CurrentUserService);

  const redirectRoute = ['webapp', 'projects'];

  if (currentUserService.isManager) {
    redirectRoute.push('manager');
  } else if (currentUserService.isPremiumSP) {
    redirectRoute.push('general-contractor');
  } else if (currentUserService.isServiceProvider) {
    redirectRoute.push('contractor');
  }

  if (redirectRoute.length <= 2) {
    // fallback to not-found if no role matches, otherwise it would create an infinite loop of redirects
    router.navigate(['not-found']);
    return;
  }

  router.navigate(redirectRoute);
};
